import { useInfiniteQuery } from "@tanstack/react-query";
import { getTokensForChain } from "./get-tokens-and-chains";

export const useTokensForChain = ({
  chainId,
  search,
}: {
  chainId: number;
  search?: string;
}) => {
  return useInfiniteQuery({
    queryKey: ["tokens", chainId, search?.toLowerCase()],
    queryFn: ({ pageParam = 0 }) =>
      getTokensForChain({
        chainId,
        offset: pageParam * 20,
        search: search,
      }),
    getNextPageParam: (lastPage, pages) =>
      lastPage.hasMore ? pages.length : undefined,
    initialPageParam: 0,
    staleTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
    retry: 1,
  });
};
